import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { PureComponent } from "react";
import classNames from "classnames";
class Pager extends PureComponent {
    constructor(props) {
        var _a, _b;
        super(props);
        this.renderPageLinks = (_a = this.renderPageLinks) === null || _a === void 0 ? void 0 : _a.bind(this);
        this.renderPreviousLink = this.renderPreviousLink.bind(this);
        this.renderNextLink = (_b = this.renderNextLink) === null || _b === void 0 ? void 0 : _b.bind(this);
    }
    renderPageLinks() {
        const result = [];
        const maxPages = 13;
        let startPage = 0;
        let endPage = maxPages;
        const deviationAroundCurrentPage = Math.ceil((maxPages - 3) / 2);
        result.push(this.renderPageLink(startPage)); // first page link
        if (this.props.totalPages <= maxPages) {
            // Show all pages
            startPage = 1;
            endPage = Math.ceil(this.props.totalPages);
        }
        else if (this.props.currentPage - deviationAroundCurrentPage <= 1) {
            // early page
            startPage = 1;
        }
        else if (this.props.currentPage + deviationAroundCurrentPage >=
            Math.floor(this.props.totalPages)) {
            // late page
            startPage = Math.ceil(this.props.totalPages) - Math.floor(maxPages - 2);
            endPage = Math.ceil(this.props.totalPages);
        }
        else {
            // middle page
            startPage = this.props.currentPage - deviationAroundCurrentPage;
            endPage = this.props.currentPage + deviationAroundCurrentPage + 1;
        }
        if (this.props.currentPage - deviationAroundCurrentPage > 1 &&
            !(startPage === 1)) {
            // first [..] box
            result.push(_jsx("li", { className: "page-item", style: { zIndex: 0 }, children: _jsx("span", { className: "page-link", children: ".." }) }, "startElipse"));
        }
        while (startPage < endPage - 1) {
            // mid page links
            result.push(this.renderPageLink(startPage));
            startPage += 1;
        }
        if (endPage <= Math.ceil(this.props.totalPages) - 1) {
            // second [..] box
            result.push(_jsx("li", { className: "page-item", style: { zIndex: 0 }, children: _jsx("span", { className: "page-link", children: ".." }) }, "endElipse"));
        }
        result.push(this.renderPageLink(Math.ceil(this.props.totalPages) - 1)); // final page link
        return result;
    }
    renderPreviousLink() {
        let disabledClass = "";
        if (this.props.currentPage === 0) {
            disabledClass = "disabled";
            return null;
        }
        return (_jsx("li", { className: `${disabledClass} page-item`, children: _jsx("button", { className: "page-link", title: "Previous Page", onClick: () => {
                    this.props.setCurrentPage(this.props.currentPage - 1);
                }, children: _jsx("span", { className: this.props.noChevron ? null : "fal fa-chevron-left", children: this.props.noChevron ? "Previous" : "" }) }) }));
    }
    renderNextLink() {
        let disabledClass = "";
        if (Math.ceil(this.props.totalPages) === this.props.currentPage + 1 ||
            this.props.totalPages < 1) {
            disabledClass = "disabled";
            return null;
        }
        return (_jsx("li", { className: `${disabledClass} page-item`, children: _jsx("button", { className: "page-link", title: "Next Page", onClick: () => {
                    this.props.setCurrentPage(this.props.currentPage + 1);
                }, children: _jsx("span", { 
                    // @ts-expect-error - TS2322 - Type 'string | null' is not assignable to type 'string | undefined'.
                    className: this.props.noChevron ? null : "fal fa-chevron-right", children: this.props.noChevron ? "Next" : "" }) }) }));
    }
    renderPageLink(page) {
        if (this.props.hidePageNumbers) {
            return null;
        }
        return (
        // Add z-index of 0 because for some reason bootstrap adds a z-index of 1
        // to active items and they it overlaps dropdown menus.
        _jsx("li", { className: this.props.currentPage === page ? "page-item active" : "page-item", style: { zIndex: 0 }, children: _jsx("button", { className: "page-link", 
                // @ts-expect-error - TS2322 - Type '{ children: number; className: string; href: string; onClick: () => void; }' is not assignable to type 'DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>'.
                href: "#", onClick: () => {
                    this.props.setCurrentPage(page);
                }, children: page + 1 }) }, `${page}-currentpage`));
    }
    render() {
        if (!this.props.totalPages || Math.ceil(this.props.totalPages) < 2) {
            return null;
        }
        return (_jsx("nav", { "aria-label": "Page navigation", className: classNames(this.props.className), children: _jsxs("ul", { className: "pagination react-pager", children: [this.renderPreviousLink(), this.renderPageLinks(), this.renderNextLink()] }) }));
    }
}
export default Pager;
